import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IsentropicService } from '../../isentropic.service';

@Component({
    selector: 'app-if-ppt',
    templateUrl: './if-ppt.component.html',
    styleUrl: './if-ppt.component.scss',
    standalone: false
})
export class IfPptComponent implements OnInit {

  pressureForm: FormGroup;
  pBool: boolean;
  pressureV: number;
  machV: number;
  gammaV: number;
  machMap:Map<string, number>;

  constructor(private isentropicService: IsentropicService, private fBuilder: FormBuilder) { 

    this.pressureForm = this.fBuilder.group({
      pressureVal: ['', [
        Validators.required,
        Validators.max(.9999999)
      ]],
      gammaVal: ['', [
        Validators.required,
        Validators.min(1.000001),
        Validators.max(1.67)
      ]]
    })
    this.pBool = false;
    this.machV = 0;
    this.gammaV = 0;
    this.machMap = new Map;
    this.pressureV = 0;

  }

  ngOnInit() {
    this.pressureForm = this.fBuilder.group({
      pressureVal: ['', [
        Validators.required,
        Validators.max(.9999999)
      ]],
      gammaVal: ['', [
        Validators.required,
        Validators.min(1.000001),
        Validators.max(1.67)
      ]]
    })
  }


  onSubmit(): void {
    this.pBool = true;
    this.pressureV = this.pressureForm.get('pressureVal')!.value;
    this.gammaV = this.pressureForm.get('gammaVal')!.value;
    this.machV = Number(this.machCalc(this.pressureV, this.gammaV));
    this.machMap = this.isentropicService.getIsentropic(this.gammaV, this.machV);
  }


  machCalc(pressure:number, gamma:number) {
    let gm1 = gamma-1;
    let invp = Math.pow(pressure, -1);
    let result = (Math.sqrt( (2/gm1) * ( Math.pow(invp, (gm1/gamma) ) -1  ))).toFixed(2);
    return result;
  }
  get pressureVal() {
    return this.pressureForm.get('pressureVal');
  }

  get gammaVal() {
    return this.pressureForm.get('gammaVal');
  }

  isenMach():number {
    return this.machV;
  }

  isenT_Tt():number {
    return this.machMap.get("T_Tt")!;
  }

  isenA_As() {
    return this.machMap.get("A_A*")
  }

  isenpA_ptAstar():number {
    return this.machMap.get("pA_ptA*")!;
  }

  isenpm() {
    return this.machMap.get("Prandlt-Meyer");
  }

  isenmach_angle() {
    return this.machMap.get("mach-angle");
  }

  isen_cfopt() {
    return this.machMap.get("C_Fopt");
  }

  isen_rhot() {
    return this.machMap.get("rho/rhot");
  }
}
